interface Props {
    id: string;
    label: string;
    value: string;
    onValueChange: (value: string, hasBadInput: boolean) => void;
    autoFocus?: boolean;
    /** Grey helper text under the input. */
    hint?: string;
    /** Inline validation message; rendered when non-null. */
    validationMessage?: string | null;
}

// Currency-adorned amount input shared by the deposit forms. A raw <input>
// (not ui/InputField) on purpose: callers need validity.badInput — Firefox
// reports non-numeric input on <input type="number"> as value === '' with
// badInput set, and without surfacing it junk input would silently read as
// "empty". The adornment mirrors the suffix pattern from ui/InputField.tsx.
const CurrencyAmountInput = ({
    id,
    label,
    value,
    onValueChange,
    autoFocus = false,
    hint,
    validationMessage,
}: Props) => (
    <div className={'flex flex-col gap-1'}>
        <label className={'text-sm font-medium text-foreground'} htmlFor={id}>
            {label}
        </label>
        <div className={'relative'}>
            <input
                id={id}
                type={'number'}
                min={0}
                step={'0.01'}
                autoFocus={autoFocus}
                className={
                    'w-full border border-foreground/15 rounded-md px-3 py-2 pr-8 text-sm focus:outline-none focus:border-primary'
                }
                value={value}
                onChange={(e) => onValueChange(e.target.value, e.target.validity.badInput)}
            />
            <span
                className={
                    'absolute right-3 top-1/2 -translate-y-1/2 text-sm text-foreground/60 pointer-events-none select-none'
                }
            >
                €
            </span>
        </div>
        {hint && <p className={'text-xs text-foreground/50'}>{hint}</p>}
        {validationMessage && <p className={'text-sm text-red-500'}>{validationMessage}</p>}
    </div>
);

export default CurrencyAmountInput;
